import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Componente", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecciona un componente", -1 /* HOISTED */)
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Atributos", -1 /* HOISTED */)
const _hoisted_6 = { class: "tableParameters" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { style: {"width":"10px"} }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Eventos", -1 /* HOISTED */)
const _hoisted_15 = { class: "tableEvents" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { style: {"width":"10px"} }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createCommentVNode("\r\n                        <i @pointerdown.stop=\"\" @dblclick.stop=\"\" aria-hidden=\"true\" class=\"fa fa-subscript\"\r\n                            @click=\"showExpression(ChangeComponentNodeConst.VAR_EVENT_IN,item.name,item)\"></i>\r\n                        ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      name: "dslist",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedComponent) = $event)),
      style: {"border":"1px solid #999","border-radius":"30px","font-size":"110%"},
      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeComponent())),
      class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dtComponentsInfo, (ds, index) => {
        return (_openBlock(), _createElementBlock("option", {
          value: ds.id,
          key: index
        }, _toDisplayString('(' + ds.id + ') - ' + ds.name), 9 /* TEXT, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
      [_vModelSelect, _ctx.selectedComponent]
    ]),
    (_ctx.selectedComponent > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onPointerdown: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
          onDblclick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
          style: {"overflow-y":"auto","overflow-x":"hidden","height":"300px"}
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Actualizable','Orden','Nombre', 'Valor', ''], (column, index) => {
                  return _createElementVNode("th", { key: index }, _toDisplayString(column), 1 /* TEXT */)
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dtComponentsVarInfo, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                      onDblclick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((item['updatable']) = $event),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeAttributeValue())),
                      class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7), [
                      [_vModelCheckbox, item['updatable']]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      onPointerdown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                      onDblclick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((item['order']) = $event),
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeAttributeValue())),
                      class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9), [
                      [_vModelText, item['order']]
                    ])
                  ]),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['name'], (column, indexColumn) => {
                    return _createElementVNode("td", { key: indexColumn }, _toDisplayString(item[column]), 1 /* TEXT */)
                  }), 64 /* STABLE_FRAGMENT */)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      onPointerdown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                      onDblclick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                      type: "text",
                      onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeAttributeValue())),
                      "onUpdate:modelValue": ($event: any) => ((item['value']) = $event),
                      class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10), [
                      [_vModelText, item['value']]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("i", {
                      onPointerdown: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                      onDblclick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                      "aria-hidden": "true",
                      class: "fa fa-subscript",
                      onClick: ($event: any) => (_ctx.showExpression(_ctx.ChangeComponentNodeConst.VAR_ATTR_IN,item.name,item))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _hoisted_12,
          (_ctx.dtComponentsEventsInfo?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Ejecutar','Orden','Nombre',''], (column, index) => {
                        return _createElementVNode("th", { key: index }, _toDisplayString(column), 1 /* TEXT */)
                      }), 64 /* STABLE_FRAGMENT */))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dtComponentsEventsInfo, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            onPointerdown: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                            onDblclick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((item['updatable']) = $event),
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeEventValue())),
                            class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16), [
                            [_vModelCheckbox, item['updatable']]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            onPointerdown: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
                            onDblclick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((item['order']) = $event),
                            onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changeEventValue())),
                            class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_18), [
                            [_vModelText, item['order']]
                          ])
                        ]),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['name'], (column, indexColumn) => {
                          return _createElementVNode("td", { key: indexColumn }, _toDisplayString(item[column]), 1 /* TEXT */)
                        }), 64 /* STABLE_FRAGMENT */)),
                        _hoisted_19
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 32 /* HYDRATE_EVENTS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}